import React from 'react';
import { motion } from 'framer-motion';
import { FaFileContract } from 'react-icons/fa';

const TermsConditions = () => {
  return (
    <div className="min-h-screen bg-gradient-to-b from-primary-50 to-white">
      {/* Header */}
      <div className="bg-gradient-to-r from-primary-600 to-nature-leaf text-white py-16">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <motion.div
            initial={{ scale: 0 }}
            animate={{ scale: 1 }}
            transition={{ duration: 0.5 }}
            className="inline-block mb-4"
          >
            <FaFileContract className="text-6xl" />
          </motion.div>
          <motion.h1
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.2 }}
            className="text-4xl md:text-5xl font-bold mb-4"
          >
            Terms & Conditions
          </motion.h1>
          <motion.p
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ delay: 0.4 }}
            className="text-lg opacity-90"
          >
            Last Updated: January 2026
          </motion.p>
        </div>
      </div>

      {/* Content */}
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.3 }}
          className="prose prose-lg max-w-none"
        >
          <div className="bg-white rounded-2xl shadow-lg p-8 mb-8">
            <p className="text-gray-700 leading-relaxed">
              Welcome to Navyaa The Home Stay. By accessing our website, making a booking, or staying at our property, you agree to comply with the following Terms and Conditions. Please read them carefully before confirming your reservation.
            </p>
          </div>

          <div className="bg-white rounded-2xl shadow-lg p-8 mb-8">
            <h2 className="text-2xl font-bold text-gray-900 mb-4">Booking and Confirmation</h2>
            <ul className="list-disc list-inside space-y-2 text-gray-700 ml-4">
              <li>All bookings are subject to availability</li>
              <li>A booking is considered confirmed only after payment or confirmation as communicated by the homestay</li>
              <li>Guests must provide accurate contact and identification details at the time of booking</li>
            </ul>
          </div>

          <div className="bg-white rounded-2xl shadow-lg p-8 mb-8">
            <h2 className="text-2xl font-bold text-gray-900 mb-4">Check In and Check Out</h2>
            <ul className="list-disc list-inside space-y-2 text-gray-700 ml-4">
              <li>Check in time: 11:00 AM</li>
              <li>Check out time: 10:00 AM</li>
              <li>Early check in or late check out is subject to availability and may attract additional charges</li>
            </ul>
          </div>

          <div className="bg-white rounded-2xl shadow-lg p-8 mb-8">
            <h2 className="text-2xl font-bold text-gray-900 mb-4">Guest Identification</h2>
            <ul className="list-disc list-inside space-y-2 text-gray-700 ml-4">
              <li>All guests are required to carry a valid government issued photo ID</li>
              <li>ID proof must be presented at the time of check in</li>
              <li>Local ID policies, if applicable, will be followed as per local regulations</li>
            </ul>
          </div>

          <div className="bg-white rounded-2xl shadow-lg p-8 mb-8">
            <h2 className="text-2xl font-bold text-gray-900 mb-4">Payment Terms</h2>
            <ul className="list-disc list-inside space-y-2 text-gray-700 ml-4">
              <li>Room tariffs are as mentioned at the time of booking</li>
              <li>Payments can be made through approved payment modes only</li>
              <li>Additional services or damages will be charged separately, if applicable</li>
            </ul>
          </div>

          <div className="bg-white rounded-2xl shadow-lg p-8 mb-8">
            <h2 className="text-2xl font-bold text-gray-900 mb-4">Cancellation and Refund Policy</h2>
            <ul className="list-disc list-inside space-y-2 text-gray-700 ml-4">
              <li>Cancellation terms will be shared at the time of booking</li>
              <li>Refunds, if applicable, will be processed as per the stated cancellation policy</li>
              <li>No refund shall be provided for early check out or no shows</li>
            </ul>
          </div>

          <div className="bg-white rounded-2xl shadow-lg p-8 mb-8">
            <h2 className="text-2xl font-bold text-gray-900 mb-4">House Rules</h2>
            <ul className="list-disc list-inside space-y-2 text-gray-700 ml-4">
              <li>Guests are expected to maintain cleanliness and decorum</li>
              <li>Loud music, parties, or disruptive behavior is not permitted</li>
              <li>Smoking is allowed only in designated areas, if applicable</li>
              <li>Pets are allowed only if explicitly mentioned or approved in advance</li>
            </ul>
          </div>

          <div className="bg-white rounded-2xl shadow-lg p-8 mb-8">
            <h2 className="text-2xl font-bold text-gray-900 mb-4">Use of Property</h2>
            <ul className="list-disc list-inside space-y-2 text-gray-700 ml-4">
              <li>Guests are responsible for the safety of their personal belongings</li>
              <li>Any damage to property, furniture, or amenities will be chargeable</li>
              <li>Illegal activities or misuse of premises will result in immediate eviction</li>
            </ul>
          </div>

          <div className="bg-white rounded-2xl shadow-lg p-8 mb-8">
            <h2 className="text-2xl font-bold text-gray-900 mb-4">Safety and Liability</h2>
            <ul className="list-disc list-inside space-y-2 text-gray-700 ml-4">
              <li>The homestay shall not be responsible for loss, theft, or damage of personal belongings</li>
              <li>Guests are advised to take care of their valuables</li>
              <li>The management is not liable for accidents or injuries caused due to negligence by guests</li>
            </ul>
          </div>

          <div className="bg-white rounded-2xl shadow-lg p-8 mb-8">
            <h2 className="text-2xl font-bold text-gray-900 mb-4">Visitor Policy</h2>
            <ul className="list-disc list-inside space-y-2 text-gray-700 ml-4">
              <li>Outside visitors are not permitted without prior approval</li>
              <li>Overnight stay of unregistered guests is strictly not allowed</li>
            </ul>
          </div>

          <div className="bg-white rounded-2xl shadow-lg p-8 mb-8">
            <h2 className="text-2xl font-bold text-gray-900 mb-4">Right to Admission</h2>
            <ul className="list-disc list-inside space-y-2 text-gray-700 ml-4">
              <li>Management reserves the right to refuse admission or cancel bookings in case of policy violation</li>
              <li>Any behavior deemed inappropriate may result in termination of stay without refund</li>
            </ul>
          </div>

          <div className="bg-white rounded-2xl shadow-lg p-8 mb-8">
            <h2 className="text-2xl font-bold text-gray-900 mb-4">Force Majeure</h2>
            <p className="text-gray-700 leading-relaxed">
              The homestay shall not be liable for delays, cancellations, or failure to provide services due to circumstances beyond its control, including natural calamities, government restrictions, or unforeseen events.
            </p>
          </div>

          <div className="bg-white rounded-2xl shadow-lg p-8 mb-8">
            <h2 className="text-2xl font-bold text-gray-900 mb-4">Changes to Terms</h2>
            <p className="text-gray-700 leading-relaxed">
              These Terms and Conditions may be updated from time to time without prior notice. Guests are advised to review this page periodically.
            </p>
          </div>

          <div className="bg-white rounded-2xl shadow-lg p-8 mb-8">
            <h2 className="text-2xl font-bold text-gray-900 mb-4">Governing Law</h2>
            <p className="text-gray-700 leading-relaxed">
              These terms shall be governed by and interpreted in accordance with the laws of India.
            </p>
          </div>

          <div className="bg-gradient-to-br from-primary-500 to-nature-leaf text-white rounded-2xl shadow-lg p-8">
            <h2 className="text-2xl font-bold mb-4">Contact Details</h2>
            <p className="leading-relaxed mb-4">
              For any queries related to booking or stay, please contact:
            </p>
            <p className="font-semibold text-lg">Navyaa The Home Stay</p>
            <p>Email: mohiteji@gmail.com</p>
            <p>Phone: +91 94200 84600</p>
          </div>
        </motion.div>
      </div>
    </div>
  );
};

export default TermsConditions;
